/*
  FILE: afs-sticky-atc.js
  PLACEMENT: Upload to Assets folder, then add this to the BOTTOM of
  sections/main-product.liquid (after the CSS tag):

    <script src="{{ 'afs-sticky-atc.js' | asset_url }}" defer></script>

  WHAT IT DOES:
  On mobile, once the native Add to Cart button scrolls out of view,
  a sticky bar appears at the bottom of the screen with the price
  and a button that submits the product form.
*/

(function () {
  if (window.innerWidth > 749) return; // desktop only — CSS handles mobile

  const productForm = document.querySelector('form[action="/cart/add"]');
  const nativeBtn = document.querySelector('.product-form__submit');
  const priceEl = document.querySelector('.price__regular .price-item--regular');

  if (!productForm || !nativeBtn) return;

  // Build sticky bar
  const bar = document.createElement('div');
  bar.className = 'afs-sticky-atc';
  bar.innerHTML = `
    <span class="afs-sticky-atc__price">${priceEl ? priceEl.textContent.trim() : ''}</span>
    <button type="button" class="afs-sticky-atc__btn">Add to Cart</button>
  `;
  document.body.appendChild(bar);

  // Hide until native button scrolls out of view
  bar.style.display = 'none';

  bar.querySelector('.afs-sticky-atc__btn').addEventListener('click', function () {
    nativeBtn.click();
  });

  // Intersection Observer on native button
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.style.display = entry.isIntersecting ? 'none' : 'flex';
    });
  }, { threshold: 0 });

  observer.observe(nativeBtn);
})();
